import { ITransactionData } from 'meta/pages/v4/transaction'
import { ApiEndpoint } from 'controller/endpoint'
import { HttpRequestForApiV4 } from 'utils/http'

type Props = {
  transactionCode: string
}

type Response = ITransactionData

export const getData = async (props: Props): Promise<Response> => {
  const { transactionCode } = props

  const endpoint = ApiEndpoint.v4.transaction.data(transactionCode)

  const { data } = await HttpRequestForApiV4.get<Response>(endpoint)
  return data
}
